<script setup lang="ts">
  import { Plus } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { Select } from "@/components/episto-ui/select";
  import { useConditionsGroupsStore } from "@stores/survey/conditions/conditionsGroups";
  import ConditionsField from "./ConditionsField.vue";
  import type { ConditionsGroup } from "@/types";

  defineProps<{
    conditionsGroups: ConditionsGroup[];
    disableAll?: boolean;
  }>();

  const conditionsGroupsStore = useConditionsGroupsStore();
  const { handleAddConditionsGroup, updateConditionsGroupOperator, removeConditionsGroup } = conditionsGroupsStore;

  const GROUP_OPERATOR_OPTIONS = [
    { value: "or", label: "Or" },
    { value: "and", label: "And" },
  ];
</script>

<template>
  <div
    class="space-y-3"
    :class="disableAll && 'opacity-50'">
    <template
      v-for="(conditionsGroup, groupIndex) in conditionsGroups"
      :key="`group-${conditionsGroup.token}`">
      <div
        v-if="groupIndex > 0"
        class="flex items-center gap-3 px-8">
        <div class="h-px flex-1 bg-border" />
        <Select
          :model-value="conditionsGroups[groupIndex - 1].group_operator || 'or'"
          :options="GROUP_OPERATOR_OPTIONS"
          :disabled="disableAll"
          variant="pill"
          class="w-20"
          placeholder="Or"
          @update:model-value="
            updateConditionsGroupOperator(conditionsGroups, { index: groupIndex - 1, value: $event })
          " />
        <div class="h-px flex-1 bg-border" />
      </div>
      <ConditionsField
        :disable-all="disableAll"
        :conditions="conditionsGroup.group_conditions"
        :group-index="groupIndex"
        :reverse-questions-options="true"
        allow-multiple
        @remove-conditions-group="removeConditionsGroup(conditionsGroups, $event)" />
    </template>
    <Button
      variant="outline"
      class="w-full shadow-xs"
      :disabled="disableAll"
      @click="handleAddConditionsGroup(conditionsGroups)">
      <Plus class="size-4" />
      {{ conditionsGroups.length ? "Add conditions group" : "Add display logic" }}
    </Button>
  </div>
</template>
